import { IconProps } from 'components/icons/Icons.types';
import React from 'react';
import styles from './Icon.module.scss';

const PenIcon: React.FC<IconProps> = ({
  className = '',
  size = 24,
  color = '#fffff0',
  fillColor = '#transparent',
  fillOpacity = 1,
  circleStrokeColor = '#fffff0',
}) => {
  const baseCls = `${styles.IconContainer} ${className}`;
  return (
    <div className={baseCls}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="transparent" xmlns="http://www.w3.org/2000/svg">
        <circle
          fill={fillColor}
          fillOpacity={fillOpacity}
          cx="12"
          cy="12"
          r="10.5"
          stroke={circleStrokeColor}
          strokeWidth={'1.5px'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m15.23 10.2-1.45-1.45.51-.51c.2-.2.52-.2.72 0l.72.72c.2.2.2.52 0 .72l-.51.51Zm-.93.93-1.45-1.45-3.27 3.27 1.45 1.45 3.27-3.27Zm2.18-4.36.72.72c.2.2.2.52 0 .72l-.45.45c.28.57.17 1.27-.3 1.75l-5.42 5.44-2.9-2.9 5.44-5.43c.47-.47 1.18-.58 1.75-.3l.45-.45c.2-.2.52-.2.72 0ZM6.62 17.35l1.09-3.98 2.89 2.89-3.98 1.09Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default PenIcon;
